import _, { isUndefined } from 'lodash';
import { notification } from 'antd';
import React from 'react';

export const errorNotification = (request, key = null) => {
  let message =
    typeof request?.responseData == 'string'
      ? JSON?.parse(JSON?.stringify(request?.responseData))?.errors?.pop()
          ?.message ??
        JSON?.parse(JSON?.stringify(request?.responseData))?.message
      : //  ? JSON?.parse(request?.responseData)?.errors?.pop()?.message ??
        //     JSON?.parse(request?.responseData)?.message
        request?.responseData;
  let errorMessages;
  if (
    !isUndefined(request?.responseData) &&
    !isUndefined(request?.originalRequest) &&
    !isUndefined(request?.responseStatus)
  ) {
    errorMessages =
      request && request?.data() && request?.data()?.errors
        ? request?.data()?.errors
        : [{ message: message }];
  } else {
    return null;
  }
  const statusCode = request?.responseStatus;
  return {
    key,
    type: 'error',
    title: statusResponseMap[statusCode],
    description: errorMessages,
    metadata: {
      status: statusCode,
      header: request?.responseHeaders,
      request: request?.originalRequest,
      response: {
        errors: request?.errors,
        content: message,
      },
    },
  };
};

export const simpleErrorNotification = (payload) => {
  const description = payload?.message ? [{ message: payload?.message }] : [];
  const statusCode = payload?.statusCode;
  return {
    type: 'error',
    title: statusResponseMap[statusCode],
    description: description,
    metadata: {
      status: statusCode,
    },
  };
};

export const warningNotification = (payload) => {
  const description = payload?.message ? [{ message: payload?.message }] : [];
  const statusCode = payload?.statusCode;
  return {
    type: 'warning',
    title: statusResponseMap[statusCode],
    description: description,
    metadata: {
      status: statusCode,
    },
  };
};

export const successNotification = (payload) => {
  const description = payload?.message ? [{ message: payload?.message }] : [];
  const statusCode = payload?.statusCode;
  return {
    type: 'success',
    title: statusResponseMap[statusCode],
    description: description,
    metadata: {
      status: statusCode,
    },
  };
};

export const infoNotification = (payload) => {
  const description = payload?.message ? [{ message: payload?.message }] : [];
  const statusCode = payload?.statusCode;
  return {
    type: 'info',
    title: statusResponseMap[statusCode],
    description: description,
    metadata: {
      status: statusCode,
    },
  };
};
/*
Show notification component as a single place to configure
 the way we manage NOTIFICATIONS everywhere
 */

function capitalize(string) {
  const lower = string?.toLowerCase();
  return string?.charAt(0)?.toUpperCase() + lower?.slice(1);
}

function extractedMessage(message, messageBody, parentKey = '') {
  if (message instanceof String) {
    messageBody += `<p>${message}</p>`;
  } else if (message instanceof Array) {
    _.forEach(message, function (item) {
      const messages = extractedMessage(item, messageBody, parentKey);
      messageBody = [...messageBody, ...messages];
    });
  } else if (message instanceof Object) {
    if ('message' in message) {
      messageBody = [
        ...messageBody,
        {
          label: message?.field ? message?.field : parentKey,
          message: message?.message,
        },
      ];
    } else if ('detail' in message) {
      messageBody = [
        ...messageBody,
        {
          label: message?.field ? message?.field : parentKey,
          message: message?.detail,
        },
      ];
    } else if ('field' in message) {
      _.forEach(message, function (value, key) {
        if (message[key] instanceof Array) {
          const messages = extractedMessage(
            message[key],
            messageBody,
            message['field']?.replaceAll('_', ' '),
          );
          messageBody = [...messageBody, ...messages];
        }
      });
    } else {
      _.forEach(message, function (value, key) {
        if (message[key] instanceof Array) {
          const messages = extractedMessage(
            message[key],
            messageBody,
            key?.replaceAll('_', ' '),
          );
          messageBody = [...messageBody, ...messages];
        }
      });
    }
  }
  return messageBody;
}

const ParseNotificationDescription = (props) => {
  const { notificationDescription } = props;
  const bodyContent = extractedMessage(notificationDescription, []);

  return (
    <div>
      {bodyContent?.map((item) => (
        <p key={_?.uniqueId()}>
          <strong>{item?.label ? `${capitalize(item?.label)}: ` : null}</strong>
          {typeof item?.message === 'object'
            ? item?.message?.message
            : item?.message}
        </p>
      ))}
    </div>
  );
};

export const showNotification = (notificationMessage, callbackReduxAction) => {
  const skippedErrorNotifications = [
    'Authorization header must contain two space-delimited values',
    'Given token not valid for any token type',
    'App/REFRESH_TOKEN_ERROR',
  ];
  if (
    skippedErrorNotifications?.includes(
      notificationMessage?.description[0]?.message,
    ) ||
    skippedErrorNotifications?.includes(notificationMessage?.key)
  ) {
    return null;
  }
  const config = {
    placement: 'topRight',
    top: 70,
    duration: 5,
    rtl: true,
    maxCount: 4,
    style: {
      backgroundColor: '#213A42',
      color: 'rgba(255, 255, 255, 0.65)',
    },
  };
  const badStates = [null, 500, 501, 502];
  return notification[notificationMessage?.type]({
    ...config,
    key: notificationMessage?.key,
    message: notificationMessage?.title,
    description: badStates?.includes(
      notificationMessage?.metadata?.status,
    ) ? null : (
      <ParseNotificationDescription
        notificationDescription={notificationMessage?.description}
      />
    ),
    onClose: callbackReduxAction,
  });
};

const statusResponseMap = {
  null: 'Unhandled Exception',
  // 1×× Informational
  100: 'Success',
  101: 'Switching Protocols',
  102: 'Processing',
  // 2×× Success
  200: 'Success',
  201: 'Created',
  202: 'Accepted',
  203: 'Non-authoritative Information',
  204: 'No Content',
  205: 'Reset Content',
  206: 'Partial Content',
  207: 'Multi-Status',
  208: 'Already Reported',
  226: 'IM Used',
  // 3×× Redirection
  300: 'Multiple Choices',
  301: 'Moved Permanently',
  302: 'Found',
  303: 'See Other',
  304: 'Not Modified',
  305: 'Use Proxy',
  307: 'Temporary Redirect',
  308: 'Permanent Redirect',
  // 4×× Client Error
  400: 'Bad Request',
  401: 'Unauthorized',
  402: 'Payment Required',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  407: 'Proxy Authentication Required',
  408: 'Request Timeout',
  409: 'Conflict',
  410: 'Gone',
  411: 'Length Required',
  412: 'Precondition Failed',
  413: 'Payload Too Large',
  414: 'Request-URI Too Long',
  415: 'Unsupported Media Type',
  416: 'Requested Range Not Satisfiable',
  417: 'Expectation Failed',
  418: "I'm a teapot",
  421: 'Misdirected Request',
  422: 'Unprocessable Entity',
  423: 'Locked',
  424: 'Failed Dependency',
  426: 'Upgrade Required',
  428: 'Precondition Required',
  429: 'Too Many Requests',
  431: 'Request Header Fields Too Large',
  444: 'Connection Closed Without Response',
  451: 'Unavailable For Legal Reasons',
  499: 'Client Closed Request',
  // 5×× Server Error
  500: 'Internal Server Error',
  501: 'Not Implemented',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
  505: 'HTTP Version Not Supported',
  506: 'Variant Also Negotiates',
  507: 'Insufficient Storage',
  508: 'Loop Detected',
  510: 'Not Extended',
  511: 'Network Authentication Required',
  599: 'Network Connect Timeout Error',
  // 6** Custom Statuses
  600: 'New Version Available',
  601: 'Alert',
};
